import { API_ENDPOINTS } from '../models/enums/endpoints.enum';
import { ApiProviderService } from './api-provider.service';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { ApplicationConfigService } from './application-config.service';
import { Observable } from 'rxjs';
import { createRequestOption } from '../app/shared/util/request-util';
import { EntityArrayResponseType, EntityResponseType } from './special-place-extended.service';
import { Injectable } from '@angular/core';
import { SpecialPlacePricingItemService } from './special-place-pricing-item.service';
import { ISpecialPlacePricingItem } from '../models/special-place-pricing-item.model';

@Injectable({ providedIn: 'root' })
export class SpecialPlacePricingItemExtendedService extends SpecialPlacePricingItemService {
  protected specialPlacePricingItemUrl = API_ENDPOINTS.SPECIAL_PLACE_PRICING_ITEMS;
  protected specialPlacePricingItemIdUrl = API_ENDPOINTS.SPECIAL_PLACE_PRICING_ITEMS_ID;

  constructor(private apiProvider: ApiProviderService, http: HttpClient, applicationConfigService: ApplicationConfigService) {
    super(http, applicationConfigService);
  }

  override create(specialPlacePricingItem: ISpecialPlacePricingItem): Observable<EntityResponseType> {
    return this.apiProvider.post<ISpecialPlacePricingItem>(this.specialPlacePricingItemUrl, specialPlacePricingItem, { observe: 'response' });
  }

  override update(specialPlacePricingItem: ISpecialPlacePricingItem): Observable<EntityResponseType> {
    return this.apiProvider.put<ISpecialPlacePricingItem>(this.specialPlacePricingItemIdUrl(specialPlacePricingItem.id!), specialPlacePricingItem);
  }

  override partialUpdate(specialPlacePricingItem: ISpecialPlacePricingItem): Observable<EntityResponseType> {
    return this.apiProvider.patch<ISpecialPlacePricingItem>(this.specialPlacePricingItemIdUrl(specialPlacePricingItem.id!), specialPlacePricingItem);
  }

  override find(id: number): Observable<EntityResponseType> {
    return this.apiProvider.get<ISpecialPlacePricingItem>(this.specialPlacePricingItemIdUrl(id), { observe: 'response' });
  }

  override query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.apiProvider.get<ISpecialPlacePricingItem[]>(this.specialPlacePricingItemUrl, {
      params: options,
      observe: 'response',
    });
  }

  override delete(id: number): Observable<HttpResponse<{}>> {
    return this.apiProvider.delete(this.specialPlacePricingItemIdUrl(id));
  }
}
